<div class="wccard p-3 mb-1">
  <app-companypage-ai [requestaidata]="skillsdataAI" [currentCompanyName]="currentCompanyName"
    [insightstabname]="'skills'" [hasMedianSalary]="hasJobDemand" [totalcount]="totalResultCount" [dataPending]="getDataPendingStatus()"></app-companypage-ai>
</div>
<div class="wccard p-3">

  <p class="f-16 font-weight-600 mb-5">Most common skills in {{currentCompanyName | titlecase}}</p>
  <p class="f-12 text-afaf mb-3">Top % Skills</p>
  <div class="d-flex justify-content-between mb-6">
    <div class="d-block" *ngFor="let skill of topFiveSkills; index as i; first as f"
      [ngStyle]="{ 'border-left': f ? null : '1px solid #d9d9d9', 'padding-left': f ? null : '12px' }">
      <div style="min-width: 160px;">
        <p class="f-12 text-afaf mb-1">#{{ i + 1 }}</p>
        <p class="f-14 font-weight-600">{{ skill.key | titlecase }}</p>
      </div>
    </div>
  </div>
  <div>

    <div *ngIf="!skills?.data?.length">
      <div class="loader text-center" *ngIf="!skillemptystate">
        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
      </div>
      <div *ngIf="skillemptystate">
        <p class="text-center small p-5">No data to display</p>
      </div>
    </div>
    <div class="mt-2" *ngIf="skills?.data?.length">
      <table mat-table [dataSource]="skills" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort
        (matSortChange)="manualSort()">

        <!-- key -->
        <ng-container matColumnDef="key">
          <th mat-header-cell mat-header-cell *matHeaderCellDef sortActionDescription="Sort by doc count"
            class="col-md-4">
            <p class="text-9696 f-12 m-0">{{tableHeaderObj['TopSkills']}} {{currentCompanyName | titlecase}}</p>
          </th>
          <td class="text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
            {{element.key | titlecase}}
          </td>
        </ng-container>

        <!-- doc_count -->
        <ng-container matColumnDef="doc_count">
          <th class="text-center col-md-2" mat-header-cell *matHeaderCellDef mat-sort-header="doc_count"
            sortActionDescription="Sort by doc count">
            <p class="text-9696 f-12 m-0"> {{tableHeaderObj['TalentCount']}} </p>
          </th>
          <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
            <span class="pointer" (click)="handelRedirection('skills', element.key)">{{element.doc_count |
              number}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="graph">
          <th class="text-center col-md-2" mat-header-cell *matHeaderCellDef mat-sort-header="graph"
            sortActionDescription="Sort by percentage">
            <p class="text-9696 f-12 m-0"> {{tableHeaderObj['%OfTotal']}} </p>
          </th>
          <td class="col-2" mat-cell *matCellDef="let element">
            <div class="progress d-flex align-items-center" style="height: 12px!important;">
              <span class="mr-1 text-484b59">
                {{getSkillPercentage(element.doc_count)}}%
              </span>
              <span class="progress-bar" role="progressbar" style="background-color: #2E93A1 !important;"
                [ngStyle]="{'width.%': getSkillPercentage(element.doc_count)}"
                aria-valuenow="getSkillPercentage(element.doc_count)" aria-valuemin="0" aria-valuemax="100"></span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="job_doc_count">
          <th class="" *matHeaderCellDef mat-header-cell>
            <p class="text-9696 f-12 m-0"
              [ngbTooltip]="jobdemand">{{tableHeaderObj['JobDemand']}}</p>
                <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
          </th>
          <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
            <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          <span class="" (click)="hasJobListingAccess &&  openJoblistSlider(element.key)" [class.pointer]="hasJobListingAccess" *ngIf="element?.job_doc_count != 0">{{element?.job_doc_count | number}}</span>
          <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
         </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <!-- <div *ngIf="skills == null || skills.length == 0">
                <p class="text-center small p-5">No data to display</p>
            </div> -->
    </div>
  </div>
</div>

<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
  <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize"
    rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false" [boundaryLinks]="false"
    [directionLinks]="false">
  </ngb-pagination>
</div>

<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
